import styled from 'styled-components';
import { tableOdd } from 'styles/Colors';

export const MeatBallsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;

  svg {
    cursor: pointer;
  }
`;

export const Control = styled.div`
  &:hover {
    cursor: pointer;
    background-color: ${tableOdd};
  }

  display: flex;
  align-items: center;
  padding: 0 8px;

  gap: 8px;
  height: 40px;
  width: 220px;
`;
